import { Outlet, useParams } from 'react-router-dom';
import SettlementHeader from './SettlementHeader';
import SettlementSidebar from './SettlementSidebar';
import FloatingChatButton from '../settlement/FloatingChatButton';
import { SettlementProvider, useSettlement } from '../../contexts/SettlementContext';

function ArchiveModeBanner() {
  const { isArchived, settledAt } = useSettlement();
  if (!isArchived) return null;
  const when = settledAt ? new Date(settledAt).toLocaleDateString() : '';
  return (
    <div
      className="bg-slate-900 text-amber-100 text-center text-sm py-2.5 px-4 border-b border-slate-700"
      role="status"
    >
      Archive mode: this estate is settled and read-only{when ? ` (closed ${when})` : ''}. You can review records but
      cannot change settlement data.
    </div>
  );
}

/**
 * Top-level layout shell for settlement routes.
 * Mirrors UnifiedLayout but uses SettlementHeader (dark navy gradient)
 * and wraps children in SettlementProvider for shared estate context.
 */
export default function SettlementLayout() {
  const { estateId } = useParams<{ estateId: string }>();

  return (
    <SettlementProvider estateId={estateId ?? null}>
      <div className="min-h-screen bg-white">
        <SettlementHeader />
        <ArchiveModeBanner />
        <SettlementSidebar>
          <Outlet />
        </SettlementSidebar>
        <FloatingChatButton />
      </div>
    </SettlementProvider>
  );
}
